// extracted by mini-css-extract-plugin
export default {"statusSelector":"CampaignPlannerInstanceDetail_statusSelector__QUGAc","source":"CampaignPlannerInstanceDetail_source__5dpaT"};